import { useCallback, useEffect, useState } from "react";
import { usePageTablePaginationContext } from "../../components/PageTablePagination/context";
import Api from "../../services/Api";
import useAuth from "../login/AuthContext";

const RESULTS_PER_PAGE = 100;

export const useRoommateListHook = (l1Id, l2Id, l3Id, page, idsInGroup) => {
  const { setTotal, setPerPage } = usePageTablePaginationContext();
  const [results, setResults] = useState({ rooms: [], total: 0, matchGroupAtLimit: false });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { getAuthToken } = useAuth();
  const [filter, setFilter] = useState({
    name: null,
    sex: null,
    renewing: null,
    smoking: null,
    pet: null,
  });

  const loadResults = useCallback(async () => {
    setLoading(true);

    const response = await Api.loadRooms(
      l1Id,
      l2Id,
      l3Id,
      page - 1,
      idsInGroup,
      filter,
      RESULTS_PER_PAGE,
      await getAuthToken()
    );

    if (response.error) {
      setError("Something bad happened");
      setLoading(false);
    } else {
      setResults(response.result);
      setPerPage(RESULTS_PER_PAGE);
      setTotal(response.result.total);
      setLoading(false);
    }
  }, [l1Id, l2Id, l3Id, page, idsInGroup.join(","), filter]);

  useEffect(() => {
    if (!l1Id || !l2Id || !l3Id) {
      setResults([]);
    }

    loadResults();
  }, [l3Id, idsInGroup.join(","), page, filter]);

  return {
    loading,
    results,
    error,
    filter,
    setFilter,
    loadResults,
  };
};
